export type TokenPayload = {
  realm_access?: { roles?: string[] };
  organization_roles?: Record<string, { roles?: string[] }>;
  organization_attribute?: Record<
    string,
    { attributes?: { compliance_backend_business_id?: string | number } }
  >;
};

const complianceRoles = new Set(['compliance_admin', 'compliance_user']);

export const getComplianceRoles = (payload: TokenPayload | null, businessId: string | null) => {
  if (!payload) return [];

  const organizations = Object.entries(payload.organization_roles || {}).filter(
    ([organizationId]) => {
      if (!businessId) return true;
      const organizationBusinessId =
        payload.organization_attribute?.[organizationId]?.attributes
          ?.compliance_backend_business_id;

      return String(organizationBusinessId) === businessId;
    },
  );

  const organizationRoles = organizations.flatMap(([, organization]) => organization.roles || []);
  const roles = businessId
    ? organizationRoles
    : [...(payload.realm_access?.roles || []), ...organizationRoles];

  return Array.from(new Set(roles.filter(role => complianceRoles.has(role)))).sort();
};

export const areRoleSetsEqual = (left: string[], right: string[]) =>
  left.length === right.length && left.every((role, index) => role === right[index]);
